<script>
  export let padding = 'md'; // sm, md, lg
  export let elevated = false;
</script>

<div class="card card-{padding} {elevated ? 'card-elevated' : ''}" on:click>
  <slot />
</div>

<style>
  .card {
    background: var(--bg-raised);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    transition: all var(--dur-med) var(--ease-out);
  }

  .card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
  }

  .card-elevated {
    box-shadow: var(--shadow-md);
  }

  .card-sm {
    padding: 1rem;
  }

  .card-md {
    padding: 1.5rem;
  }

  .card-lg {
    padding: 2rem;
  }
</style>
